import { PackEditorTabMode } from 'enums';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import {
  updateAreSettingsValid,
  updateValidationErrors
} from 'store/reducer/setting/slice';
import TabBodyRevamp from 'components/setting-generator-revamp/tabs-revamp/TabBodyRevamp';
import { resolveSettingsContentMode } from 'utils/settings.util';
import {
  getValidationErrors,
  validateSettingsData
} from 'utils/validators/settingsValidation';
import { packAndFocusEditorSelector } from 'store/reducer/selectors/pack-and-focus-editor.selector';
import MorningAdvancedModal from './MorningAdvancedModal';

const EditorBody = () => {
  const dispatch = useAppDispatch();
  const {
    currentSettings,
    mode,
    packEditorTabMode,
    isUserAdmin,
    isTextEditorWithinCharacterLimit,
    currentViewedFocusTemplate,
    routineTimeValidation,
    isShowRoutineModal
  } = useAppSelectorShallow(packAndFocusEditorSelector);

  const contentMode = resolveSettingsContentMode(mode, packEditorTabMode);

  useEffect(() => {
    const isDataValid = validateSettingsData(
      currentSettings,
      currentViewedFocusTemplate,
      contentMode,
      isTextEditorWithinCharacterLimit,
      routineTimeValidation,
      isUserAdmin
    );
    dispatch(updateAreSettingsValid(isDataValid));
  }, [
    currentSettings,
    contentMode,
    currentViewedFocusTemplate,
    isTextEditorWithinCharacterLimit,
    routineTimeValidation,
    isUserAdmin,
    dispatch
  ]);

  useEffect(() => {
    const nextErrors = getValidationErrors(
      contentMode === PackEditorTabMode.FOCUS_MODE ? null : currentSettings,
      contentMode,
      contentMode === PackEditorTabMode.FOCUS_MODE
        ? currentViewedFocusTemplate
        : null,
      isTextEditorWithinCharacterLimit,
      isUserAdmin
    );
    dispatch(updateValidationErrors(nextErrors));
  }, [
    currentSettings,
    currentViewedFocusTemplate,
    dispatch,
    isTextEditorWithinCharacterLimit,
    isUserAdmin,
    contentMode
  ]);

  return (
    <>
      <div className='flex-1 min-h-0 overflow-y-auto scrollbar-thin-custom'>
        <TabBodyRevamp />
      </div>
      {isShowRoutineModal && <MorningAdvancedModal />}
    </>
  );
};

export default EditorBody;
